import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import './GameRulesPageNew.scss';

// Create a component for a section
const RulesPageSection = ({ title, content }) => {
  return (
    <Box className='rules-page-text-group'>
      <Typography className='rules-page-body-title'>
        {title}
      </Typography>
      {content?.map((item, index) => {
        if (item?.type === 'text') {
          return (
            <Typography 
              key={index} 
              className={`rules-page-body-text ${item?.bold ? 'bold' : ''} ${item?.centered ? 'centered' : ''}`}
            >
              {item?.content}
            </Typography>
          );
        } else if (item?.type === 'image') {
          return (
            <Box key={index}>
              <img 
                style={{
                  display: 'block',
                  margin: '0 auto',
                  width: item?.width || '95%',
                  maxWidth: item?.maxWidth || '400px',
                  height: 'auto',
                  marginBottom: item?.marginBottom || '32px',
                  marginTop: item?.marginTop || '0px'
                }} 
                src={item?.src} 
                alt={item?.alt || title} 
              />
            </Box>
          );
        }
        return null;
      })}
    </Box>
  );
};

export default RulesPageSection